/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Search_Guides_Gridcraft_Excel_Compatibility_Sections_1_Steps_4Inputs */

const en_gc_search_guides_gridcraft_excel_compatibility_sections_1_steps_4 = /** @type {(inputs: Gc_Search_Guides_Gridcraft_Excel_Compatibility_Sections_1_Steps_4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reopen the downloaded copy in Excel. Compare the changed total, the formula itself, the number formats and any charts you rely on. If Excel offers to repair the file, keep the original and investigate before using the exported copy.`)
};

const zh_gc_search_guides_gridcraft_excel_compatibility_sections_1_steps_4 = /** @type {(inputs: Gc_Search_Guides_Gridcraft_Excel_Compatibility_Sections_1_Steps_4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`在 Excel 中重新打开下载的副本。对比修改后的合计、公式本身、数字格式及重要图表。如果 Excel 提示修复文件，请保留原件，查明原因后再使用导出的副本。`)
};

/**
* | output |
* | --- |
* | "Reopen the downloaded copy in Excel. Compare the changed total, the formula itself, the number formats and any charts you rely on. If Excel offers to repair ..." |
*
* @param {Gc_Search_Guides_Gridcraft_Excel_Compatibility_Sections_1_Steps_4Inputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_search_guides_gridcraft_excel_compatibility_sections_1_steps_4 = /** @type {((inputs?: Gc_Search_Guides_Gridcraft_Excel_Compatibility_Sections_1_Steps_4Inputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Search_Guides_Gridcraft_Excel_Compatibility_Sections_1_Steps_4Inputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_search_guides_gridcraft_excel_compatibility_sections_1_steps_4(inputs)
	return zh_gc_search_guides_gridcraft_excel_compatibility_sections_1_steps_4(inputs)
});
export { gc_search_guides_gridcraft_excel_compatibility_sections_1_steps_4 as "gc.search_guides.gridcraft_excel_compatibility.sections.1.steps.4" }